import React, { useState } from "react";

import { useIsMobile } from "src/shared/utilities/customHooks";

import VoucherModal from "../VoucherModal/VoucherModal";
import * as S from "./styled";

const MWebVoucherBadge = () => {
  const isMobile = useIsMobile();
  const [modalOpen, setModalOpen] = useState(false);
  const handleModalOpen = () => setModalOpen(true);
  const handleModalClose = () => setModalOpen(false);

  if (!isMobile) {
    return null;
  }

  return (
    <S.MWebVoucherBadgeContainer>
      <S.MWebVoucherBadgeText>
        Searching with a housing voucher, like Section 8?
      </S.MWebVoucherBadgeText>
      <S.MWebVoucherButton onClick={handleModalOpen}>
        See Tips
      </S.MWebVoucherButton>
      <VoucherModal isOpen={modalOpen} onRequestClose={handleModalClose} />
    </S.MWebVoucherBadgeContainer>
  );
};

export default MWebVoucherBadge;
